const modes = [
  { label: 'graph_options.modes.average_price_per_hour', value: 'averagePricePerHour' },
  { label: 'graph_options.modes.total_price', value: 'totalPrice' },
  { label: 'graph_options.modes.total_duration', value: 'totalDuration' },
];

export default modes;
